function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Global } from "@emotion/core";
import { useTheme } from "../";
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function GlobalStyles(_ref) {
  var useDarkMode = _ref.useDarkMode,
      customStyles = _ref.customStyles;
  var theme = useTheme();
  var cssCustomPropertiesColors = Object.keys(theme.colors).reduce(function (obj, c) {
    obj["--colors-" + c] = theme.colors[c];
    return obj;
  }, {});
  var cssCustomPropertiesDarkColors = Object.keys(theme.dark).reduce(function (obj, c) {
    if (theme.colors[c] !== theme.dark[c]) obj["--colors-" + c] = theme.dark[c];
    return obj;
  }, {});
  return ___EmotionJSX(Global, {
    styles: _extends({
      ":root": _extends({
        fontSize: "100%"
      }, cssCustomPropertiesColors),
      body: {
        fontSize: "1rem",
        fontFamily: theme.fonts.web,
        WebkitFontSmoothing: "subpixel-antialiased",
        MozOsxFontSmoothing: "grayscale",
        backgroundColor: "var(--colors-base)",
        color: "var(--colors-primary)"
      },
      "*": {
        margin: "0",
        padding: "0",
        boxSizing: "border-box"
      },
      strong: {
        fontWeight: theme.fontWeights.bold
      },
      a: {
        color: "var(--colors-primary)"
      }
    }, useDarkMode ? {
      "@media (prefers-color-scheme: dark)": {
        ":root": _extends({}, cssCustomPropertiesDarkColors)
      }
    } : {}, customStyles)
  });
}